module.exports = __webpack_public_path__ + "assets/img/00120.88133de4.png";